import React, { PureComponent, Component } from 'react';
import { Row, Col, Popover } from 'antd';
import { stat } from 'fs';

class SchedulingOrderStatus extends Component {
    constructor() {
        super();
        this.state = {
            cols:
                <Row type="flex" justify="space-between" align="middle">
                </Row>
        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }
    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    updateStatus(theData) {
        if (theData !== null && !this.isEmptyObj(theData)  && theData.process !== null && theData.process.length !== 0) {
            this.initStatus(theData.process);
        }else{
            this.setState({ cols: [] });
        }
    }

    /* componentWillReceiveProps(nextProps) {
        if(nextProps!==null && !this.isEmptyObj(nextProps) && nextProps.data!==null && !this.isEmptyObj(nextProps.data) && nextProps.data.process!==null && nextProps.data.process.length!==0 ){
            this.initStatus(nextProps.data.process);
        }
    } */

    initStatus(theData) {
        let aCols = [];
        let aStyle = {};
        for (var i = 0; i < theData.length; i++) {
            if (theData[i].status !== null && theData[i].status.length !== 0) {
                aStyle = {};
                if (theData[i].status.toUpperCase() === "READY") {
                    aStyle = { width: 16, height: 16, backgroundColor: "RoyalBlue", margin: 6 };
                } else if (theData[i].status.toUpperCase() === "RUNNING") {
                    aStyle = { width: 16, height: 16, backgroundColor: "Chartreuse", margin: 6 };
                } else if (theData[i].status.toUpperCase() === "DONE") {
                    aStyle = { width: 16, height: 16, backgroundColor: "Red", margin: 6 };
                }
                if (!this.isEmptyObj(aStyle)) {
                    aCols.push(
                        <Col>
                            <Popover content={theData[i].name + ": " + theData[i].status}>
                                <div style={aStyle}></div>
                            </Popover>
                        </Col>
                    );
                }
            }
        }
        this.setState({ cols: aCols });
    }

    isEmptyObj(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop))
                return false;
        }
        return JSON.stringify(obj) === JSON.stringify({});
    }

    render() {
        return (
            <div id="schedulingorderstatus">
                <Row type="flex" justify="space-between" align="middle">
                    {this.state.cols}
                </Row>
            </div>
        );
    }
}

export default SchedulingOrderStatus;



// WEBPACK FOOTER //
// ./src/Componets/SchedulingOrderStatus.js